import * as React from 'react';
import { SVGProps } from 'react';

const SvgEditOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m18.018 3.776 2.206 2.206a.946.946 0 0 1 0 1.336l-1.729 1.729-3.542-3.542 1.729-1.729a.946.946 0 0 1 1.336 0ZM3.5 18.615a4 4 0 0 1 1.172-2.829l9.28-9.28 3.542 3.542-9.28 9.28A4 4 0 0 1 5.385 20.5H3.5v-1.885Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgEditOutlined;
